import $ from "jquery";
import ko from "knockout";

/**
 * toggleClick Binding Handler (wrapper)
 *
 * Used to easily bind a click on an element to toggle the observable
 */

ko.bindingHandlers.toggleClick = {
    init: function (element, valueAccessor) {
        const value = valueAccessor();
        $(element).on("click", function (event) {
            value(!value());
            event.preventDefault();
        });
    },
};
